
    import './styles.scoped.css';
    export default {
  "background": "awsui_background_hyvsj_zz5e8_99",
  "scrolling-background": "awsui_scrolling-background_hyvsj_zz5e8_102",
  "sticky-background": "awsui_sticky-background_hyvsj_zz5e8_108",
  "has-sticky-notifications": "awsui_has-sticky-notifications_hyvsj_zz5e8_116",
  "breadcrumbs": "awsui_breadcrumbs_hyvsj_zz5e8_129",
  "has-sticky-background": "awsui_has-sticky-background_hyvsj_zz5e8_139",
  "drawers-container": "awsui_drawers-container_hyvsj_zz5e8_151",
  "has-open-drawer": "awsui_has-open-drawer_hyvsj_zz5e8_162",
  "disable-body-scroll": "awsui_disable-body-scroll_hyvsj_zz5e8_185",
  "drawers-desktop-triggers-container": "awsui_drawers-desktop-triggers-container_hyvsj_zz5e8_190",
  "has-multiple-triggers": "awsui_has-multiple-triggers_hyvsj_zz5e8_231",
  "drawers-mobile-triggers-container": "awsui_drawers-mobile-triggers-container_hyvsj_zz5e8_241",
  "drawers-trigger-content": "awsui_drawers-trigger-content_hyvsj_zz5e8_245",
  "drawers-trigger-overflow": "awsui_drawers-trigger-overflow_hyvsj_zz5e8_259",
  "drawers-trigger": "awsui_drawers-trigger_hyvsj_zz5e8_245",
  "drawer": "awsui_drawer_hyvsj_zz5e8_151",
  "drawer-content-container": "awsui_drawer-content-container_hyvsj_zz5e8_290",
  "drawer-close-button": "awsui_drawer-close-button_hyvsj_zz5e8_299",
  "drawer-content": "awsui_drawer-content_hyvsj_zz5e8_290",
  "drawer-content-hidden": "awsui_drawer-content-hidden_hyvsj_zz5e8_307",
  "drawer-slider": "awsui_drawer-slider_hyvsj_zz5e8_310",
  "is-drawer-open": "awsui_is-drawer-open_hyvsj_zz5e8_317",
  "content": "awsui_content_hyvsj_zz5e8_343",
  "layout": "awsui_layout_hyvsj_zz5e8_364",
  "has-max-content-width": "awsui_has-max-content-width_hyvsj_zz5e8_447",
  "content-type-dashboard": "awsui_content-type-dashboard_hyvsj_zz5e8_462",
  "content-type-table": "awsui_content-type-table_hyvsj_zz5e8_476",
  "content-type-cards": "awsui_content-type-cards_hyvsj_zz5e8_476",
  "is-overlap-disabled": "awsui_is-overlap-disabled_hyvsj_zz5e8_482",
  "is-hide-mobile-toolbar": "awsui_is-hide-mobile-toolbar_hyvsj_zz5e8_485",
  "has-content-gap-left": "awsui_has-content-gap-left_hyvsj_zz5e8_517",
  "has-content-gap-right": "awsui_has-content-gap-right_hyvsj_zz5e8_520",
  "content-first-child-notifications": "awsui_content-first-child-notifications_hyvsj_zz5e8_530",
  "has-breadcrumbs": "awsui_has-breadcrumbs_hyvsj_zz5e8_533",
  "content-first-child-header": "awsui_content-first-child-header_hyvsj_zz5e8_536",
  "has-header": "awsui_has-header_hyvsj_zz5e8_536",
  "content-first-child-main": "awsui_content-first-child-main_hyvsj_zz5e8_557",
  "disable-content-paddings": "awsui_disable-content-paddings_hyvsj_zz5e8_557",
  "has-split-panel": "awsui_has-split-panel_hyvsj_zz5e8_600",
  "split-panel-position-bottom": "awsui_split-panel-position-bottom_hyvsj_zz5e8_600",
  "block-body-scroll": "awsui_block-body-scroll_hyvsj_zz5e8_616",
  "unfocusable": "awsui_unfocusable_hyvsj_zz5e8_621",
  "container": "awsui_container_hyvsj_zz5e8_631",
  "is-navigation-open": "awsui_is-navigation-open_hyvsj_zz5e8_657",
  "is-tools-open": "awsui_is-tools-open_hyvsj_zz5e8_660",
  "is-split-panel-open": "awsui_is-split-panel-open_hyvsj_zz5e8_660",
  "split-panel-position-side": "awsui_split-panel-position-side_hyvsj_zz5e8_660",
  "has-active-drawer": "awsui_has-active-drawer_hyvsj_zz5e8_660",
  "mobile-toolbar": "awsui_mobile-toolbar_hyvsj_zz5e8_669",
  "remove-high-contrast-header": "awsui_remove-high-contrast-header_hyvsj_zz5e8_686",
  "mobile-toolbar-nav": "awsui_mobile-toolbar-nav_hyvsj_zz5e8_690",
  "mobile-toolbar-breadcrumbs": "awsui_mobile-toolbar-breadcrumbs_hyvsj_zz5e8_694",
  "mobile-toolbar-tools": "awsui_mobile-toolbar-tools_hyvsj_zz5e8_698",
  "navigation-container": "awsui_navigation-container_hyvsj_zz5e8_707",
  "show-navigation": "awsui_show-navigation_hyvsj_zz5e8_751",
  "animating": "awsui_animating_hyvsj_zz5e8_774",
  "showButtons": "awsui_showButtons_hyvsj_zz5e8_1",
  "navigation": "awsui_navigation_hyvsj_zz5e8_707",
  "openNavigation": "awsui_openNavigation_hyvsj_zz5e8_1",
  "animated-content": "awsui_animated-content_hyvsj_zz5e8_836",
  "hide-navigation": "awsui_hide-navigation_hyvsj_zz5e8_845",
  "notifications": "awsui_notifications_hyvsj_zz5e8_855",
  "sticky-notifications": "awsui_sticky-notifications_hyvsj_zz5e8_861",
  "split-panel-bottom": "awsui_split-panel-bottom_hyvsj_zz5e8_878",
  "position-bottom": "awsui_position-bottom_hyvsj_zz5e8_925",
  "openSplitPanelBottom": "awsui_openSplitPanelBottom_hyvsj_zz5e8_1",
  "split-panel-side": "awsui_split-panel-side_hyvsj_zz5e8_954",
  "position-side": "awsui_position-side_hyvsj_zz5e8_967",
  "tools-container": "awsui_tools-container_hyvsj_zz5e8_989",
  "tools": "awsui_tools_hyvsj_zz5e8_989",
  "openTools": "awsui_openTools_hyvsj_zz5e8_1",
  "has-tools-form-persistence": "awsui_has-tools-form-persistence_hyvsj_zz5e8_1086",
  "hide-tools": "awsui_hide-tools_hyvsj_zz5e8_1096",
  "show-tools": "awsui_show-tools_hyvsj_zz5e8_1108",
  "has-tools-form": "awsui_has-tools-form_hyvsj_zz5e8_1086",
  "trigger-badge-wrapper": "awsui_trigger-badge-wrapper_hyvsj_zz5e8_1191",
  "trigger": "awsui_trigger_hyvsj_zz5e8_1191",
  "selected": "awsui_selected_hyvsj_zz5e8_1265",
  "badge": "awsui_badge_hyvsj_zz5e8_1285",
  "trigger-wrapper": "awsui_trigger-wrapper_hyvsj_zz5e8_1289",
  "dot": "awsui_dot_hyvsj_zz5e8_1300"
};
  